import React, { memo } from 'react';
import { Form, Input, Modal } from 'antd';
import {
  useActions,
  useEditorWatch,
  useModalActions,
  useModalState,
} from '../../provider';
import { eventNames, modalNames } from '../../config';
import { useApplyLink } from '../../hooks/useApplyLink';

const name = modalNames.phone;
const preparePhone = (phone) => phone.split(' ').join('');
const Container = ({ form }) => {
  const { getFieldDecorator, validateFields, resetFields } = form;

  const { close } = useModalActions();
  const { onChange, getEditorState } = useActions();

  const { isOpen, props } = useModalState(name);
  const { phone, dopPhone, text, editMode } = props || {};

  const applyLink = useApplyLink();

  const onCancel = () => close(name);

  const handleOk = (e) => {
    e.preventDefault();

    validateFields((err, values) => {
      if (!err) {
        const { text, phone, dopPhone } = values;
        const preparedPhone = preparePhone(phone);
        const normalizedPhone = dopPhone
          ? `${preparedPhone}p${dopPhone}`
          : preparedPhone;

        const textToInsert = text?.trim() || normalizedPhone;

        const newState = applyLink(
          {
            state: getEditorState(),
            text: textToInsert,
            url: `tel:${normalizedPhone}`,
          },
          editMode
        );
        onChange(newState);
        onCancel();
      }
    });
  };

  return (
    <Modal
      visible={isOpen}
      afterClose={resetFields}
      onCancel={onCancel}
      onOk={handleOk}
    >
      <Form>
        <TextField
          getFieldDecorator={getFieldDecorator}
          initialValue={text}
        />
        <PhoneField
          getFieldDecorator={getFieldDecorator}
          initialValue={phone}
        />
        <DopPhoneField
          getFieldDecorator={getFieldDecorator}
          initialValue={dopPhone}
        />
      </Form>
    </Modal>
  );
};

const PhoneLinkModal = Form.create({ name: 'editor-phone-link-modal' })(
  Container
);
export default memo(PhoneLinkModal);

function TextField({ getFieldDecorator, initialValue = '' }) {
  const isSelectionCollapsed = useEditorWatch(
    eventNames.selectionCollapsedChange
  );

  return (
    <Form.Item label={isSelectionCollapsed ? 'Текст' : ''}>
      {getFieldDecorator('text', { initialValue })(
        <Input
          placeholder="Введите текст для номера телефона..."
          disabled={!isSelectionCollapsed}
          hidden={!isSelectionCollapsed}
        />
      )}
    </Form.Item>
  );
}

function PhoneField({ getFieldDecorator, initialValue = '' }) {
  return (
    <Form.Item label="Телефон">
      {getFieldDecorator('phone', {
        initialValue,
        rules: [
          { required: true, message: 'Укажите номер телефона' },
          {
            // eslint-disable-next-line no-useless-escape
            pattern: new RegExp(/^[\d\+\()][\d\(\)\ -]{4,14}\d$/),
            message: 'Некорректный номер телефона',
          },
        ],
      })(<Input placeholder="Введите номер телефона..." />)}
    </Form.Item>
  );
}

function DopPhoneField({ getFieldDecorator, initialValue = '' }) {
  return (
    <Form.Item label="Добавочный номер">
      {getFieldDecorator('dopPhone', {
        initialValue,
        rules: [
          {
            pattern: new RegExp(/^\d+$/),
            message: 'Некорректный добавочный номер',
          },
        ],
      })(<Input placeholder="Введите добавочный номер без решетки..." />)}
    </Form.Item>
  );
}
